import { render, staticRenderFns } from "./EditImageForList.vue?vue&type=template&id=ff4e88ec&scoped=true&"
import script from "./EditImageForList.ts?vue&type=script&lang=ts&"
export * from "./EditImageForList.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff4e88ec",
  null
  
)

export default component.exports